import Header from './Header';
import LearningHeader from './learning-header/LearningHeader';
import messages from './i18n/index';

export { LearningHeader, messages };

export default Header;
